import { InjectionToken } from '@angular/core';

export interface SelectedDocumentExportAccepted {
    readonly jobId: string;
    readonly jobType: 'SelectedBuildingDocumentExport';
    readonly statusUrl: string;
    readonly createdAt: string;
    readonly expiresAt?: string | null;
}

export type SelectedDocumentExportAcceptance = ((
    buildingId: string,
    accepted: SelectedDocumentExportAccepted,
    selectionKey: string
) => boolean) & { readonly isCurrent: () => boolean };

export interface SelectedDocumentExportHandoff {
    capture(): SelectedDocumentExportAcceptance | null;
}

export const SELECTED_DOCUMENT_EXPORT_HANDOFF =
    new InjectionToken<SelectedDocumentExportHandoff>(
        'SELECTED_DOCUMENT_EXPORT_HANDOFF'
    );
